// src/components/common/CoupangAdBlock.js
import React from "react";

// ✅ 여기만 바꾸면 전체 광고 이미지/링크가 바뀜

export const COUPANG_AD_CONFIG = {
  robotCleanerA: {
    href: "https://link.coupang.com/a/dancAX",
    imgSrc:
      "https://img5c.coupangcdn.com/image/affiliate/event/promotion/2025/12/02/385af67d8a650071018abc6e30da9018.png",
    imgAlt: "주방용품, Merry 주방용품 SALE 12/24 A",
  },
  robotCleanerB: {
    href: "https://link.coupang.com/a/dandFY",
    imgSrc:
      "https://img3a.coupangcdn.com/image/affiliate/event/promotion/2025/12/02/b75a567d2265000e018ab16e30d9941b.png",
    imgAlt: "가전디지털, 로봇청소기 셀렉트샵 12/27 B",
  },
  robotCleanerC: {
    href: "https://link.coupang.com/a/dam8UT",
    imgSrc:
      "https://image1.coupangcdn.com/image/affiliate/event/promotion/2025/05/02/31cd586fab4800bd0193ef0fb3ceb1f1.png",
    imgAlt: "가구리빙 251228 C",
  },
};

function CoupangAdBlock({ adKey = "robotCleanerA", placement }) {
  const ad = COUPANG_AD_CONFIG[adKey] ?? COUPANG_AD_CONFIG.robotCleanerA;

  return (
    <div className={`coupang-ad coupang-ad--${placement || "default"}`}>
      <a
        href={ad.href}
        target="_blank"
        rel="noopener noreferrer"
        className="coupang-ad-banner-link"
      >
        <img
          src={ad.imgSrc}
          alt={ad.imgAlt}
          className="coupang-ad-banner-img"
        />
      </a>
      <p className="coupang-ad-note" style={{ fontSize: "1rem" }}>
        이 포스팅은 쿠팡 파트너스 활동의 일환으로, <br />
        이에 따른 일정액의 수수료를 제공받습니다.
      </p>
    </div>
  );
}

export default CoupangAdBlock;
